import {Routes, Route, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core/PageData'
import {ListUser} from '../users/components/ListUser'
import {EventSubscriptionsRoutes} from './component/eventsSubscription/EventSubscriptionsRoutes'
import {SuspensedView} from '../../routing/PrivateRoutes'
import {ServerRoutes} from './component/servers/ServerRoutes'
import {DataMartLogsList} from './component/DataMartLogsList'
import {useIntl} from 'react-intl'
import {ServerGroupRoutes} from './component/serverGroups/ServerGroupRoutes'

const SystemSettingsRoutes = () => {
  const intl = useIntl()
  const breadcrumbs: Array<PageLink> = [
    {
      title: 'Arteco Insight',
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  return (
    <Routes>
      <Route
        path='event-subscription/*'
        element={
          // eslint-disable-next-line react/jsx-no-undef
          <SuspensedView>
            <EventSubscriptionsRoutes />
          </SuspensedView>
        }
      />
      <Route
        path='servers/*'
        element={
          // eslint-disable-next-line react/jsx-no-undef
          <SuspensedView>
            <ServerRoutes />
          </SuspensedView>
        }
      />
      <Route
        path='server-groups/*'
        element={
          // eslint-disable-next-line react/jsx-no-undef
          <SuspensedView>
            <ServerGroupRoutes />
          </SuspensedView>
        }
      />
      <Route
        path='datamart-logs'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS.STATISTICS_GENERATION_LOGS'})}
            </PageTitle>
            <DataMartLogsList />
          </>
        }
      />
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}
export {SystemSettingsRoutes}
